import { useHasSoftPull } from '~/contexts/FinanceAndTradeContext';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';

export default function useTermsAreLocked() {
  const isInTileExperiment = useCheckExperimentBucket(
    'srp-tile-unlock-monthly',
    'experiment'
  );

  const hasValidSoftPull = useHasSoftPull();

  return !hasValidSoftPull && isInTileExperiment;
}
